export default "__VITE_ASSET__DdX_lTCZ__"